import { Injectable } 			from '@angular/core';
import { Http, Headers, 
		 Response, 
		 URLSearchParams } 		  from '@angular/http';
import { Observable } 			from 'rxjs/Rx'
import { Router }           from '@angular/router';
import { StorageService}    from './storage.service';

@Injectable()
export class RolesService {
  constructor(public router: Router, private storage: StorageService){
   
  }

  private getToken() {
    let user = this.storage.getObject('user');
    return user["api_token"];
  }

  isAdmin() {
    let current_user = this.storage.getObject('user');
    let isAdmin = false;
    if(this.checkIfRole()) {
      if(current_user.role.name == "Administrator") {
        isAdmin = true;
      }
    } else {
      this.logout();
    }

    return isAdmin;
  }

  isLeader() {
    let isAdmin = false;
    let current_user = this.storage.getObject('user');
    if(this.checkIfRole()) {
      if(current_user.role.name == "Leader") {
        isAdmin = true;
      }
    } else {
      this.logout();
    }

    return isAdmin;
  }

  isFamily() {
    let isAdmin = false;
    let current_user = this.storage.getObject('user');
    if(this.checkIfRole()) {
      if(current_user.role.name == "Participant Family") {
        isAdmin = true;
      }
    } else {
      this.logout();
    }

    return isAdmin;
  }
  isStudent() {
    let isAdmin = false;
    let current_user = this.storage.getObject('user');
    if(this.checkIfRole()) {
      if(current_user.role.name == "Student") {
        isAdmin = true;
      }
    } else {
      this.logout();
    }

    return isAdmin;
  }
  isTeam(){
    let isAdmin = false;
    let current_user = this.storage.getObject('user');
    if(this.checkIfRole()) {
      if(current_user.role.name == "Team") {
        isAdmin = true;
      }
    } else {
      this.logout();
    }

    return isAdmin;
  }
  canGoHere(roles:Array<string>) {
    let isAdmin = false;
    let current_user = this.storage.getObject('user');
    if(this.checkIfRole()) {
      if(roles.indexOf(current_user.role.name) != -1) {
        isAdmin = true;
      }
    } else {
      this.logout();
    }

    return isAdmin;
  }

  checkIfRole() {
    let role = false;
    let current_user = this.storage.getObject('user');
    if(current_user) {
      if(current_user.role) {
        role = true;
      }
    } else {
      this.logout();
    }

    return role;
  }

  logout() {
    this.storage.removeAll();
    this.router.navigate(['users/login']);
  }

  
}


// WEBPACK FOOTER //
// ./src/app/_services/roles.service.ts